module.exports = __webpack_public_path__ + "static/media/ad4.18732830.png";